<template>
  <div class="index-details">
    <gj-analysis-panel
        :title="'指标明细'"
    >
      <template #subtitle>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh', 'setting']"
            @refresh="refresh"
            @openCustomColumnModal="openCustomColumnModal"
        />
      </template>
      <template #panelBody>
        <div class="index-details-content">
          <el-row :gutter="10">
            <el-col :span="24">
                <gj-table
                    :width="'100%'"
                    :height="390"
                    ref="gjTable"
                    :adapt-height="false"
                    :index="false"
                    :pagination="pagination"
                    :loading="loading"
                    :data="tableData"
                    :columns="columns"
                    :default-sort="{prop: 'unitsOrdered', order: 'descending'}"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery"
                >
                  <template v-slot:header:goods>
                      <div class="goods-header" @click="handleQueryGoodsInfo('')">
                        <gj-icon iconfont="iconback" style="color: #666; margin-right: 5px; cursor: pointer" ></gj-icon>
                        <span>{{ currentGoodsColumnName | optionText(marketOption) | defaultShow }}</span>
                      </div>
                     <span>商品标题/ASIN</span>
                  </template>
                  <template v-slot:good="{ row }">
                    <div class="flex base-info">
                      <gj-image
                              :src="row.imageUrl"
                              tag-color="rgb(246 144 10)">
                      </gj-image>
                      <div class="base-info__content">
                        <gj-tooltip
                                :text-line="1"
                                :content="row.crawlTitle">
                          <div class="base-info__content--title text-ellipsis-1">{{ row.crawlTitle | defaultShow }}</div>
                        </gj-tooltip>
                        <div class="base-info__content--asin">
                          <span>ASIN: <em class="value" style="cursor: pointer;" @click="navigateTo(row.asinUrl)">{{ row.asin | defaultShow }}</em></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:marketId="{row}">
                      <gj-tooltip
                                :text-line="1"
                                :content="row.marketId | optionText(marketOption)">
                          <gj-button type="text" @click="handleQueryGoodsInfo(row.marketId)">{{ row.marketId | optionText(marketOption) | defaultShow }}</gj-button>
                        </gj-tooltip>
                    <!-- <gj-button type="text" @click="handleQueryGoodsInfo(row.marketId)">{{ row.marketId | optionText(marketOption) | defaultShow }}</gj-button> -->
                  </template>
                  <template v-slot:unitsOrdered="{row}">
                    {{row.unitsOrdered}}
                    <ChainRatio :itemKey="'unitsOrdered'" :isBlock="true" :percent="parseInt(row['unitsOrdered' + 'Compare'])"/>
                  </template>
                  <template v-slot:orders="{row}">
                    {{row.orders}}
                    <ChainRatio :itemKey="'orders'" :isBlock="true" :percent="parseInt(row['orders' + 'Compare'])"/>
                  </template>
                  <template v-slot:orderProductSales="{row}">
                    {{ row.currencySymbol }}{{ row["orderProductSales"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'orderProductSales'" :isBlock="true" :percent="parseInt(row['orderProductSales' + 'Compare'])"/>
                  </template>
                  <template v-slot:refunds="{row}">
                    {{row.refunds}}
                    <ChainRatio :itemKey="'refunds'" :isBlock="true" :percent="parseInt(row['refunds' + 'Compare'])"/>
                  </template>
                  <template v-slot:refundsRate="{row}">
                    {{row.refundsRate}}%
                    <ChainRatio :itemKey="'refundsRate'" :isBlock="true" :percent="parseInt(row['refundsRate' + 'Compare'])"/>
                  </template>
                  <template v-slot:returnProductSales="{row}">
                    {{ row.currencySymbol }}{{ row["returnProductSales"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'returnProductSales'" :isBlock="true" :percent="parseInt(row['returnProductSales' + 'Compare'])"/>
                  </template>
                  <template v-slot:returns="{row}">
                    {{row.returns}}
                    <ChainRatio :itemKey="'returns'" :isBlock="true" :percent="parseInt(row['returns' + 'Compare'])"/>
                  </template>
                  <template v-slot:returnsRate="{row}">
                    {{row.returnsRate}}%
                    <ChainRatio :itemKey="'returnsRate'" :isBlock="true" :percent="parseInt(row['returnsRate' + 'Compare'])"/>
                  </template>
                  <template v-slot:avgUnitsOrderedSales="{row}">
                    {{ row.currencySymbol }}{{ row["avgUnitsOrderedSales"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'avgUnitsOrderedSales'" :isBlock="true" :percent="parseInt(row['avgUnitsOrderedSales' + 'Compare'])"/>
                  </template>

                  <template v-slot:sessionsMobile="{ row }">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                        {{ row.sessionsMobile | defaultShow }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                      {{ row.sessionsMobile | defaultShow }}
                    </span>
                    <ChainRatio :itemKey="'sessionsMobile'" :isBlock="true" :percent="parseInt(row['sessionsMobile' + 'Compare'])"/>
                  </template>
                  <template v-slot:sessionsBrowser="{ row }">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                        <span class="trafficError">
                          {{ row.sessionsBrowser | defaultShow }}
                        </span>
                      </gj-tooltip>
                      <span v-else>
                        {{ row.sessionsBrowser | defaultShow }}
                      </span>
                      <ChainRatio :itemKey="'sessionsBrowser'" :isBlock="true" :percent="parseInt(row['sessionsBrowser' + 'Compare'])"/>
                  </template>
                   <template v-slot:sessions="{row}">
                     <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                        <span class="trafficError">
                           {{ row.sessions | defaultShow }}
                        </span>
                     </gj-tooltip>
                     <span v-else>
                           {{ row.sessions | defaultShow }}
                     </span>
<!--                    {{ row.sessions }}-->
                    <ChainRatio :itemKey="'sessions'" :isBlock="true" :percent="parseInt(row['sessions' + 'Compare'])"/>
                  </template>

                  <template v-slot:unitSessionPercentage="{row}">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                         {{ row.unitSessionPercentage | defaultShow('','%') }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                       {{ row.unitSessionPercentage | defaultShow('','%') }}
                    </span>
<!--                    {{ row.unitSessionPercentage }}%-->
                    <ChainRatio :itemKey="'unitSessionPercentage'" :isBlock="true" :percent="parseInt(row['unitSessionPercentage' + 'Compare'])"/>
                  </template>

<!--                    {{ row.pageViews }}-->
                  <template v-slot:pageViewsMobile="{row}">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                        {{ row.pageViewsMobile | defaultShow }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                      {{ row.pageViewsMobile | defaultShow }}
                    </span>
                    <ChainRatio :itemKey="'pageViews'" :isBlock="true" :percent="parseInt(row['pageViewsMobile' + 'Compare'])"/>
                  </template>

                  <template v-slot:pageViewsBrowser="{row}">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                        {{ row.pageViewsBrowser | defaultShow }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                      {{ row.pageViewsBrowser | defaultShow }}
                    </span>
                    <ChainRatio :itemKey="'pageViews'" :isBlock="true" :percent="parseInt(row['pageViewsBrowser' + 'Compare'])"/>
                  </template>

                  <template v-slot:pageViews="{row}">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                        {{ row.pageViews | defaultShow }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                      {{ row.pageViews | defaultShow }}
                    </span>
<!--                    {{ row.pageViews }}-->
                    <ChainRatio :itemKey="'pageViews'" :isBlock="true" :percent="parseInt(row['pageViews' + 'Compare'])"/>
                  </template>

                  <template v-slot:buyBoxPercentage="{row}">
                    <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
                      <span class="trafficError">
                         {{ row.buyBoxPercentage | defaultShow('','%') }}
                      </span>
                    </gj-tooltip>
                    <span v-else>
                       {{ row.buyBoxPercentage | defaultShow('','%') }}
                    </span>
<!--                    {{ row.buyBoxPercentage }}%-->
                    <ChainRatio :itemKey="'buyBoxPercentage'" :isBlock="true" :percent="parseInt(row['buyBoxPercentage' + 'Compare'])"/>
                  </template>


                  <template v-slot:adsSpend="{row}">
                    {{ row.currencySymbol }}{{ row["adsSpend"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'adsSpend'" :isBlock="true" :percent="parseInt(row['adsSpend' + 'Compare'])"/>
                  </template>
                  <template v-slot:adsSales="{row}">
                    {{ row.currencySymbol }}{{ row["adsSales"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'adsSales'" :isBlock="true" :percent="parseInt(row['adsSales' + 'Compare'])"/>
                  </template>
                  <template v-slot:acoS="{row}">
                    {{row.acoS + "%"}}
                    <ChainRatio :itemKey="'acoS'" :isBlock="true" :percent="parseInt(row['acoS' + 'Compare'])"/>
                  </template>
                  <template v-slot:adsImpressions="{row}">
                    {{row.adsImpressions}}
                    <ChainRatio :itemKey="'adsImpressions'" :isBlock="true" :percent="parseInt(row['adsImpressions' + 'Compare'])"/>
                  </template>
                  <template v-slot:clicks="{row}">
                    {{row.adsClicks}}
                    <ChainRatio :itemKey="'adsClicks'" :isBlock="true" :percent="parseInt(row['adsClicks' + 'Compare'])"/>
                  </template>
                  <template v-slot:ctr="{row}">
                    {{row.ctr + "%"}}
                    <ChainRatio :itemKey="'ctr'" :isBlock="true" :percent="parseInt(row['ctr' + 'Compare'])"/>
                  </template>
                  <template v-slot:adsOrders="{row}">
                    {{row.adsOrders}}
                    <ChainRatio :itemKey="'adsOrders'" :isBlock="true" :percent="parseInt(row['adsOrders' + 'Compare'])"/>
                  </template>
                  <template v-slot:cr="{row}">
                    {{row.cr + "%"}}
                    <ChainRatio :itemKey="'cr'" :isBlock="true" :percent="parseInt(row['cr' + 'Compare'])"/>
                  </template>
                  <template v-slot:cpc="{row}">
                    {{ row.currencySymbol }}{{ row["cpc"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'cpc'" :isBlock="true" :percent="parseInt(row['cpc' + 'Compare'])"/>
                  </template>
                  <template v-slot:roAS="{row}">
                    {{row.roAS + "%"}}
                    <ChainRatio :itemKey="'roAS'" :isBlock="true" :percent="parseInt(row['roAS' + 'Compare'])"/>
                  </template>
                  <template v-slot:asoAS="{row}">
                    {{row.asoAS + "%"}}
                    <ChainRatio :itemKey="'asoAS'" :isBlock="true" :percent="parseInt(row['asoAS' + 'Compare'])"/>
                  </template>
                  <template v-slot:acoAS="{row}">
                    {{row.acoAS + "%"}}
                    <ChainRatio :itemKey="'acoAS'" :isBlock="true" :percent="parseInt(row['acoAS' + 'Compare'])"/>
                  </template>
                  <template v-slot:totalIncome="{row}">
                    {{ row.currencySymbol }}{{ row["totalIncome"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'totalIncome'" :isBlock="true" :percent="parseInt(row['totalIncome' + 'Compare'])"/>
                  </template>
                  <template v-slot:totalExpenditure="{row}">
                    {{ row.currencySymbol }}{{ row["totalExpenditure"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'totalExpenditure'" :isBlock="true" :percent="parseInt(row['totalExpenditure' + 'Compare'])"/>
                  </template>
                  <template v-slot:salesGrossProfit="{row}">
                    {{ row.currencySymbol }}{{ row["salesGrossProfit"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'salesGrossProfit'" :isBlock="true" :percent="parseInt(row['salesGrossProfit' + 'Compare'])"/>
                  </template>
                  <template v-slot:grossProfitRate="{row}">
                    {{row.grossProfitRate + "%"}}
                    <ChainRatio :itemKey="'grossProfitRate'" :isBlock="true" :percent="parseInt(row['grossProfitRate' + 'Compare'])"/>
                  </template>
                  <template v-slot:salesNetProfit="{row}">
                    {{ row.currencySymbol }}{{ row["salesNetProfit"] | amount | defaultShow }}
                    <ChainRatio :itemKey="'salesNetProfit'" :isBlock="true" :percent="parseInt(row['salesNetProfit' + 'Compare'])"/>
                  </template>
                  <template v-slot:salesNetProfitRate="{row}">
                    {{row.salesNetProfitRate + "%"}}
                    <ChainRatio :itemKey="'salesNetProfitRate'" :isBlock="true" :percent="parseInt(row['salesNetProfitRate' + 'Compare'])"/>
                  </template>
                  <template v-slot:midBadReview="{row}">
                    {{row.midBadReview}}
                    <ChainRatio :itemKey="'midBadReview'" :isBlock="true" :percent="parseInt(row['midBadReview' + 'Compare'])"/>
                  </template>
                  <template v-slot:midBadFeedback="{row}">
                    {{row.midBadFeedback}}
                    <ChainRatio :itemKey="'midBadFeedback'" :isBlock="true" :percent="parseInt(row['midBadFeedback' + 'Compare'])"/>
                  </template>
                  <template v-slot:fulfillableQuantity="{row}">
                    {{row.fulfillableQuantity}}
                  <ChainRatio :itemKey="'fulfillableQuantity'" :isBlock="true" :percent="parseInt(row['fulfillableQuantity' + 'Compare'])"/>
                  </template>
                  <template v-slot:fulfillableAmount="{row}">
                    {{row.fulfillableAmount}}
                  <ChainRatio :itemKey="'fulfillableAmount'" :isBlock="true" :percent="parseInt(row['fulfillableAmount' + 'Compare'])"/>
                  </template>
                  <template v-slot:saleableTurnover="{row}">
                    {{row.saleableTurnover}}
                  <ChainRatio :itemKey="'saleableTurnover'" :isBlock="true" :percent="parseInt(row['saleableTurnover' + 'Compare'])"/>
                  </template>
                </gj-table>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {queryMixin} from "@/minxins";
import { getIndexDetails } from "@/api/statistics"
import _ from "lodash"
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"
import {mapGetters} from "vuex";
import {convertToFullDate, dateShortcut,} from "@/utils/date.util";
import {getCustomColumns} from "@/api/common";
import {indexDetails} from "@/views/modules/statistics/shop-wide-analysis/common/fields";

const storageDetailColumn = {
  id: 'storageDetail', header: "库存", align: 'center', children: [
    {id: 'fulfillableQuantity', header: "FBA可售", field: 'slot:fulfillableQuantity', minWidth: '120px', align: 'right'},
    {id: 'fulfillableAmount', header: "FBA可售货值", field: 'slot:fulfillableAmount', minWidth: '120px', align: 'right', prefix: 'currencySymbol'},
    {id: 'saleableTurnover', header: "FBA可售周转", field: 'slot:saleableTurnover', minWidth: '120px', align: 'right'}
]};

const buyerCommentsColumn = {
  id: 'buyerComments', header: '买家评论', align: 'center', children: [
    {id: 'midBadReview', header: 'review中差评', field: 'slot:midBadReview', minWidth: '120px', align: 'right', default: true, summary: true},
    {id: 'midBadFeedback', header: 'feedback中差评', field: 'slot:midBadFeedback', minWidth: '130px', align: 'right', prefix: 'currencySymbol', default: true, summary: true},
    ]};

export default {
  name: "index-details",
  components: {OptionGroup, ChainRatio},
  mixins: [queryMixin],
  inject: ['getPageParams'],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    filter () {
      return this.getPageParams()
    },
    startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
  },
  data(){
    return{
      useCache: false,
      settingName: "indexDetails",
      loading: false,
      profitAnalysisOption: {},
      moduleColumns: [
        {id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '90px', align: 'center'},
        ...indexDetails
      ],
      marketColumn: {id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '90px', align: 'center'},
      goodsColumn: {id: 'good', header: 'slot:goods', field: 'slot:good', minWidth: '280px', align: 'left'},
      groupType: '',
      currentGoodsColumnName: '',
      columns: [],
      tableData: [],
      marketId:''
    }
  },
  methods: {
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      //获取概览自定义列
      this.getIndexDetails();
    },
    /**
     * 刷新当前模块
     */
    refresh(){
      this.$gjQuery();
    },
    /**
     * 获取自定义列
     */
    getCustomColumns(){
      return getCustomColumns(this.settingName).then(res => {
        let list = this.checkList = res ? res.split(",") : [];
        this.cleanColumns(list);
      })
    },
    /**
     * 动态清洗渲染表格动态列
     */
    cleanColumns(columns){
      const moduleColumns = this.moduleColumns.filter(v => v.id !== (this.groupType === 'asin' ? 'buyerComments' : 'storageDetail'))
      this.columns = _.cloneDeep(moduleColumns).filter(e=> {
        if(!_.isEmpty(e.children)){
          e.children = e.children.filter(v => {
            v.checked = !_.isEmpty(columns) ? _.includes(columns, v.id || v.key) : v.default;
            return v;
          })
        }
        return e;
      })
      this.moduleColumns = _.cloneDeep(this.moduleColumns).map(e => {
        if(!_.isEmpty(e.children)){
          e.children = e.children.filter(v => {
            v.checked = !_.isEmpty(columns) ? _.includes(columns, v.id || v.key) : v.default;
            return v;
          })
        }
        return e;
      });
    },
    /**
     * 切换指标明细
     */
    handleQueryGoodsInfo (marketId = '') {
        this.groupType = marketId ? 'asin' : ''
        this.currentGoodsColumnName = marketId
        this.marketId = marketId
        this.columns = this.moduleColumns.filter(v => v.id !== (this.groupType === 'asin' ? 'buyerComments' : 'storageDetail'))

        this.columns.shift()
        this.columns.unshift(this.groupType === 'asin' ? this.goodsColumn : this.marketColumn)

        this.$gjQuery();
    },
    /**
     * 打开设置弹窗
     */
    openCustomColumnModal(){
      const _this = this;
      let moduleColumns = [];
      this.moduleColumns.forEach(e => {
        moduleColumns = _.concat(moduleColumns, e.children ? [...e.children] : e)
      });

      this.$gjCreate('gj-setting-custom-modal', {
        props: {
          name: this.settingName,
          size: 'middle',
          checks: this.checkList,
          moduleColumns: moduleColumns,
          title: "至少选中一个指标"
        },
        on: {
          ['check-list'](columns) {
            //获取设置回调，动态渲染表格列
            _this.cleanColumns(columns);
            //存档
            _this.checkList = columns;
          },
          ['check-list-items'](columns) {
            _this.refresh()
          }
        }
      });
    },
    /**
     * 获取指标明细数据
     */
    getIndexDetails(){
      const params = {
        model: {
          ...this.filter,
          groupType: this.groupType,
          countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
          marketIds : this.marketId === '' ? (this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null) : this.marketId.split(),
        },
        ...this.queryPagination,
        ...this.querySort
      };
      this.loading = true;
      getIndexDetails(params).then(res=>{
        this.columns.shift()
        this.columns.unshift(this.groupType === 'asin' ? this.goodsColumn : this.marketColumn)
        this.$nextTick(() => {
          let data = res;
          let records = _.get(res, "page.records", []);
          let thanData = data.thanData || [];
          //PS 环比数需要通过marketId 去 thanData 去拿，然后塞回 records 里面
          records = _.map(records,m=>{
            let filterItem = thanData.find(v => this.groupType === 'asin' ? v.asin === m.asin : v.marketId === m.marketId)
            if(!_.isEmpty(filterItem)){
              for(let key in filterItem){

                const filterVal = _.toNumber(filterItem[key])
                const originalVal = _.toNumber(m[key])
                const reduceValue = originalVal- filterVal
                m[key + "Compare"] = filterVal && originalVal ? (reduceValue / Math.abs(filterVal)) * 100 : null;
              }
            }
            return m;
          })
          this.tableData = records;
          if(data.page){
            this.pagination = this.getPagination(data.page);
          }

          //拼装表格数据
        })
      }).complete(()=>{this.loading = false;})
    },
    getPagination(queryResponse) {
      return {
        currentPage: queryResponse.current,
        pageSize: queryResponse.size,
        total: queryResponse.total,
      };
    },
    navigateTo (url) {
      if (url) {
        window.open(url, '_blank')
      }
    }
  },
  created() {
    this.sort.prop = "unitsOrdered"
    this.getCustomColumns().then(() => {
      this.$gjQuery();
    });

  }
}
</script>

<style lang="scss" scoped>
@import "../common/index.scss";
.index-details{
  margin-top: 10px;
  padding: 0 0;
}
.el-button--text{
      width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.base-info {

  &__content {
    margin-left: 13px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;
    &--title {
      color: #333333;
    }

    &--asin {
      color: #666666;

      > span {
        margin-right: 10px;

        .value {
          color: #1F6EEF;
          font-style: normal;
        }
      }
    }
  }
}
.trafficError{
  color:#F5222D;
}
</style>
